export default __webpack_public_path__ + "static/119-1b90917d03a8c89234f3bb8e7f2c8392.jpg";